import { h, Component, Fragment, createRef } from "preact";
import PropTypes from "prop-types";
import { sendRequest, validateEmail } from "../../tools";
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";
import MeterReading from "./MeterReading";

export default class ServiceFormCertificateNoDebt extends Component {
  static propTypes = {
    urlCreate: PropTypes.string.isRequired,
    urlSubmitMeterReading: PropTypes.string.isRequired,
    urlGetEnergyDebt: PropTypes.string.isRequired,
    urlGetMeterDevice: PropTypes.string.isRequired,
    urlOrderContractPay: PropTypes.string.isRequired,
    urlSendData: PropTypes.string.isRequired,
    urlCheck: PropTypes.string.isRequired,
    urlAddServiceOrder: PropTypes.string.isRequired,
    contracts: PropTypes.array.isRequired,
    cost: PropTypes.number.isRequired,
    products: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    onSubmited: PropTypes.func,
    typeForm: PropTypes.string,
    firstName: PropTypes.string,
    secondName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.phoneInputRef = createRef();
    this.state = {
      values: {
        meterDevices: [],
      },
      loading: false,
      timer: 0,
    };
    this.submitted = false;
    this.requiredFields = [
      "city",
      "contractGlobalId",
      "street",
      "house",
      "lastName",
      "firstName",
      "phoneNumber",
      "email",
    ];
    this.fieldsName = {
      regPointId: "Номер прибора учета",
      lastName: "Фамилия",
      firstName: "Имя",
      phoneNumber: "Номер телефона",
      email: "E-mail",
      city: "Город",
      contractGlobalId: "Номер договора",
      street: "Улица",
      house: "Дом",
      products: "Услуга",
      reading: "Показания",
      debt: "Долг",
      meterReading: "",
    };
    this.errorsApi = {};
  }

  clearForm = () => {
    this.submitted = false;
    this.errorsApi = {};
    const contract = this.props.contracts[0];
    $(this.phoneInputRef.current).val("");

    this.setState({
      values: {
        lastName: "",
        firstName: this.props.firstName,
        surname: this.props.secondName,

        phoneNumber: this.props.phone,
        email: this.props.email,
        paymentType: "",
        products: this.props.products,
        contractGlobalId: contract.contractGlobalId,
        regPointId: contract["meterDevice"].length
          ? contract["meterDevice"][0].serialNumber
          : "",
        contractId: contract.contractId,
        accountId: contract.accountId,
        city: contract.city,
        street: contract.street,
        house: contract.house,
        flat: contract.flat,
        reading: false,
        debt: undefined,
        meterDevices: [],
      },
      timer: 0,
    });
    $(this.phoneInputRef.current).inputmask("setvalue", this.props.phone);
    setTimeout(() => {
      this.getMeterDevices(contract.contractId);
      // this.availabilityCheckService(contract);
    }, 100);
  };

  componentDidMount() {
    const self = this;
    self.clearForm();
    $(this.phoneInputRef.current).inputmask({
      mask: "+7 (999) 999 9999",
      clearIncomplete: true,
      oncomplete: function (e) {
        self.setValues({ phoneNumber: e.target.value });
      },
      onincomplete: function () {
        self.setValues({ phoneNumber: "" });
      },
    });
  }

  render(props, state, context) {
    const self = this;
    const errors = { ...this.errorsApi, ...this.validate() };
    const { values } = state;

    return (
      <form className="form">
        <div className="form__body">
          <div className="form-block__section form-block__section_pdb_none">
            <div className="modal-2__section-inner">
              <div className="form__title-2">{props.productName}*</div>
              <div className="form__fieldset">
                <div className="form__fieldset-title">Данные абонента</div>
                <div className="form__item form__item_horizontal">
                  <TextInput
                    errors={errors.lastName}
                    isRequired={this.isRequired("lastName")}
                    name="Фамилия"
                    inputProps={{
                      onChange: this.onChangeInput("lastName"),
                      value: values.lastName,
                      placeholder: "Введите фамилию",
                      id: "lastName",
                    }}
                  />
                  <TextInput
                    errors={errors.firstName}
                    isRequired={this.isRequired("firstName")}
                    name="Имя"
                    inputProps={{
                      onChange: this.onChangeInput("firstName"),
                      value: values.firstName,
                      placeholder: "Введите имя",
                      id: "firstName",
                    }}
                  />
                  <TextInput
                    errors={errors.surname}
                    isRequired={this.isRequired("surname")}
                    name="Отчество (при наличии)"
                    inputProps={{
                      onChange: this.onChangeInput("surname"),
                      value: values.surname,
                      placeholder: "Введите отчество",
                      id: "surname",
                    }}
                  />
                </div>
                <div className="form__item">
                  <div className="form-field form-field_gray">
                    <div className="form-field__inner">
                      <div className="form-field__title-row">
                        <legend className="form-field__title">
                          {this.isRequired("contractGlobalId")}Адрес
                        </legend>
                      </div>
                      <div
                        className={`form-field__input-row ${
                          "city" in errors ||
                          "street" in errors ||
                          "house" in errors ||
                          "account" in errors
                            ? "form-field_state_error"
                            : ""
                        }`}
                      >
                        <SelectInput
                          onChange={this.onChangeAddress}
                          defaultValue=""
                          name="address"
                          checkedItem={values.contractGlobalId}
                          getItemName={(item) => item.address}
                          getItemValue={(item) => item.contractGlobalId}
                          items={this.props.contracts}
                          isCheckedValue={(item) =>
                            item.contractGlobalId === values.contractGlobalId
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <MeterReading
            url={props.urlSubmitMeterReading}
            contractId={values.contractId}
            meterDevices={values.meterDevices}
            regPointId={values.regPointId}
            reading={values.reading}
            onSaved={this.getMeterDevices}
          />
          <div className="form-block__section form-block__section_pdt_none form-block__section_mgt_none">
            <div className="modal-2__section-inner">
              <div className="form__fieldset">
                <div className="form__fieldset-title">Стоимость услуги</div>
                <div className="form__item">
                  <div className="form-info-block">
                    <div className="form-info-block__item">
                      <div className="form-info-block__name">
                        Общая стоимость
                      </div>
                      <div className="form-info-block__value">
                        {props.cost.toLocaleString("ru-RU", {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 0,
                        })}{" "}
                        р
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form__fieldset">
                <div className="form__fieldset-title">Контактные данные</div>
                <div className="form__item form__item_horizontal">
                  <div
                    className={`form-field form-field_gray ${
                      errors.phoneNumber ? "form-field_state_error" : ""
                    }`}
                  >
                    <div className="form-field__inner">
                      <div className="form-field__title-row">
                        <label
                          className="form-field__title"
                          htmlFor="phoneNumber"
                        >
                          {this.isRequired("phoneNumber")}Номер телефона
                        </label>
                      </div>
                      <div className="form-field__input-row">
                        <input
                          className="input form-field__input"
                          type="text"
                          id="phoneNumber"
                          ref={this.phoneInputRef}
                        />
                      </div>
                    </div>
                  </div>
                  <TextInput
                    errors={errors.email}
                    isRequired={this.isRequired("email")}
                    name="Почта"
                    inputProps={{
                      onChange: this.onChangeInput("email"),
                      value: values.email,
                      placeholder: "Введите почту",
                      id: "email",
                    }}
                  />
                </div>
              </div>
              <fieldset className="form__fieldset">
                <div className="form__fieldset-title">Задолженность</div>
                <div className="form__item">
                  <div className="form-info-block">
                    <div className="form-info-block__item">
                      <div className="form-info-block__name">Ваш долг</div>
                      <div className="form-info-block__value">
                        {typeof values.debt === "undefined"
                          ? ""
                          : values.debt.toLocaleString("ru-RU", {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 0,
                            }) + " р"}
                      </div>
                      <div className="form-info-block__buttons-wrap">
                        <button
                          className="form-info-block__button button-secondary button-secondary_pdv_sm-1"
                          disabled={!!state.timer}
                          onclick={this.checkDebt}
                          type="button"
                        >
                          {" "}
                          Узнать задолженность{" "}
                          {!!state.timer ? "(" + state.timer + ")" : ""}
                        </button>
                        <button
                          className="form-info-block__button button-primary button-primary_pdv_sm-1 button-primary_bgc_brand-2"
                          disabled={
                            !(
                              typeof values.debt !== "undefined" &&
                              values.debt > 0
                            )
                          }
                          type="button"
                          data-modal-url={
                            props.urlOrderContractPay +
                            "?contractId=" +
                            values.contractId +
                            "&accountId=" +
                            values.accountId +
                            "&amount=" +
                            values.debt
                          }
                        >
                          Оплатить
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="form__subtext">
                    Прохождение платежа может занять несколько минут
                  </div>
                </div>
              </fieldset>

              <fieldset className="form__fieldset">
                <div className="form__item">
                  * Заявки принимаются по адресам, где электросчетчик является
                  расчетным. По нерасчетным счетчикам, отсутствии или
                  неисправности прибора учета заявки на получение справок об
                  отсутствии задолженности принимаются через раздел «
                  <a href="/appeal/" target="_blank">
                    Задать вопрос
                  </a>
                  »
                </div>
              </fieldset>
            </div>

            <div className="form__footer">
              {!!errors &&
                Object.values(errors).map((item) => {
                  return <p className="form__error-text">{item}</p>;
                })}
              <button
                onClick={this.onSubmitForm}
                disabled={Object.keys(errors).length}
                className="button-primary button-primary_pdv_lg form__submit-btn"
              >
                {this.state.loading ? "Отправка заявки" : "Отправить заявку"}
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }

  checkDebt = () => {
    this.timer(10);
    this.getDebts();
  };

  getDebts = () => {
    const formData = new FormData();
    formData.append("contractId", this.state.values.contractId);

    sendRequest(this.props.urlGetEnergyDebt, {
      body: formData,
      type: "POST",
      showLoader: true,
    }).then((data) => {
      if (data.status === 200) {
        this.setValues({ debt: data.data });
      }
      if (data.status >= 500 || data.status === 0) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
      }
    });
  };

  timer = (total) => {
    const self = this;
    self.setState({ timer: total });
    const timerId = setInterval(function () {
      --total;
      self.setState({ timer: total });

      if (total <= 0) {
        clearInterval(timerId);
      }
    }, 1000);
  };

  validate = () => {
    let errors = {};
    const self = this;
    if (!this.submitted) return errors;

    const { values } = this.state;

    this.requiredFields.forEach((requiredField) => {
      if (
        typeof values[requiredField] === "undefined" ||
        values[requiredField] === null ||
        values[requiredField].length === 0
      ) {
        const fieldName =
          requiredField in self.fieldsName
            ? self.fieldsName[requiredField]
            : "";
        errors[requiredField] = `"${fieldName}" обязательно для заполнения`;
      }
    });

    if (values.email && !validateEmail(values.email)) {
      errors.email = "E-mail заполнен неверно";
    }

    if (!values.reading) {
      errors.reading = "Для получения справки передайте показания";
    }

    if (typeof values.debt === "undefined") {
      errors.debt = "Для получения справки узнайте задолженность";
    }

    if (values.debt && values.debt > 0) {
      errors.debt = "Для получения справки оплатите долг";
    }

    return errors;
  };

  isRequired = (fieldName) =>
    this.requiredFields.indexOf(fieldName) !== -1 ? "* " : "";

  onChangeAddress = (e) => {
    const contract = this.props.contracts.find(
      (item) => item.contractGlobalId === e.target.value
    );
    this.setValues({
      contractGlobalId: e.target.value,
      regPointId: contract.meterDevice.length
        ? contract.meterDevice[0].serialNumber
        : "",
      contractId: contract.contractId,
      accountId: contract.accountId,
      city: contract.city,
      street: contract.street,
      house: contract.house,
      flat: contract.flat,
      reading: false,
      debt: undefined,
      meterDevices: [],
    });

    this.getMeterDevices(contract.contractId);
    // this.availabilityCheckService(contract);
  };

  // ENERGYWEB-730 Убрано ограничение на заказ только 1 справки в день
  availabilityCheckService = (contract) => {
    const self = this;
    const formData = new FormData();
    formData.append("accountId", contract.accountId);
    formData.append("abonentId", contract.abonentId);
    formData.append("contractId", contract.contractId);
    formData.append("bspid", contract.bspid);
    formData.append("serviceId", self.props.products);

    sendRequest(self.props.urlCheck, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: false,
    }).then((data) => {
      if (data.data) {
        self.errorsApi["account"] =
          "Сегодня вы уже заказывали эту услугу для этого ЛС";
      } else {
        delete self.errorsApi["account"];
      }
      self.forceUpdate();
    });
  };

  getMeterDevices = (contractId) => {
    const self = this;
    const formData = new FormData();
    formData.append("contractId", contractId);

    sendRequest(self.props.urlGetMeterDevice, {
      body: formData,
      type: "POST",
      showLoader: true,
    }).then((data) => {
      if (data.status === 200) {
        let reading = false;
        const now = new Date();
        const curDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        );

        data.data.forEach((item) => {
          const input = item.dateMeterReading.match(/\d+/g),
            dateReading = new Date(input[2], input[1] - 1, input[0]);

          reading =
            dateReading.getFullYear() === curDate.getFullYear() &&
            dateReading.getMonth() === curDate.getMonth() &&
            dateReading.getDate() === curDate.getDate();
        });

        self.setValues({
          meterDevices: data.data,
          reading: reading,
          debt: undefined,
        });
      }
    });
  };

  onChangeInput = (field) => (e) => {
    this.setValues({ [field]: e.target.value });
  };

  setValues = (values) => {
    this.removeErrorsApi(values);
    this.setState((state, props) => ({
      values: {
        ...state.values,
        ...values,
      },
    }));
  };

  removeErrorsApi = (fields) => {
    const self = this;
    Object.keys(fields).map((field) => {
      if (field in self.errorsApi) {
        delete self.errorsApi[field];
      }
    });
  };

  orderCert = (orderId) => {
    const formData = new FormData();
    const { values } = this.state;
    const contract = this.props.contracts.find(
      (item) => item.contractGlobalId === values.contractGlobalId
    );

    formData.append("contractId", contract.contractId);
    formData.append("paid", this.props.cost);
    formData.append("bspid", contract.bspid);
    formData.append("email", values.email);
    formData.append("orderId", orderId);

    sendRequest(this.props.urlSendData, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: false,
    }).then(
      (data) => {},
      (error) => null
    );
  };

  // ENERGYWEB-730 Убрано ограничение на заказ только 1 справки в день
  addOrderToHistory = (contract) => {
    const formAddOrder = new FormData();
    formAddOrder.append("accountId", contract.accountId);
    formAddOrder.append("abonentId", contract.abonentId);
    formAddOrder.append("contractId", contract.contractId);
    formAddOrder.append("bspid", contract.bspid);
    formAddOrder.append("serviceId", this.props.products);

    sendRequest(self.props.urlAddServiceOrder, {
      body: formAddOrder,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: false,
    }).then(
      (data) => {},
      (error) => null
    );
  };

  onSubmitForm = (e) => {
    e.preventDefault();
    const self = this;
    this.submitted = true;
    const errors = this.validate();
    if (Object.keys(errors).length || Object.keys(self.errorsApi).length) {
      this.forceUpdate();
      return;
    }

    this.setState({ loading: true });

    const formData = new FormData();
    const { values } = self.state;
    const contract = self.props.contracts.find(
      (item) => item.contractGlobalId === values.contractGlobalId
    );
    let meterDevice = contract.meterDevice.find(
      (item) => item.serialNumber === values.regPointId
    );
    if (!meterDevice) {
      meterDevice = {
        name: "Нет данных",
        regPointId: values.regPointId,
      };
    }

    formData.append("typeForm", self.props.typeForm);
    formData.append("contractGlobalId", values.contractGlobalId);
    formData.append("city", values.city);
    formData.append("street", values.street);
    formData.append("house", values.house);
    formData.append("flat", values.flat);
    formData.append("regPointId", meterDevice.regPointId);
    formData.append("regPointName", meterDevice.name);
    formData.append("lastName", values.lastName);
    formData.append("firstName", values.firstName);
    formData.append("surname", values.surname);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("email", values.email);
    formData.append("products[]", values.products);

    sendRequest(self.props.urlCreate, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: true,
    })
      .then((data) => {
        self.setState({ loading: false });
        if (data.status === 200) {
          try {
            this.orderCert(data.data["orderId"]);
          } catch (e) {}

          // try {
          // 	this.addOrderToHistory(contract);
          // } catch(e) {}

          this.clearForm();
          if (typeof self.props.onSubmited === "function") {
            self.props.onSubmited();
          }
        }
        if (data.status === 422) {
          JSON.parse(data.data).map((item) => {
            self.errorsApi[item["field"]] = item.message;
          });
        }
        if (data.status >= 500 || data.status === 0) {
          $.disMsg(
            "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
            { type: "false" }
          );
        }
      })
      .catch((error) => {});
  };
}
